import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import {TaskManagementApiService} from '../../task-api.service';
import {minimumArrayLengthValidator} from 'src/app/shared/validators/min-arr-length.validator';
import {TranslateService} from '@ngx-translate/core';
import {LayoutAlertService} from 'src/app/admin/layout-alert.service';

export function ValidateDays(control: AbstractControl) {
  const val = control.value;
  if (val.length < 1) {
    return {invalidTemplateUse: true};
  }
  return null;
}

@Component({
    selector: 'app-products-for-customer-ticket-upload',
    templateUrl: './products-for-customer-ticket-upload.component.html',
    styleUrls: ['./products-for-customer-ticket-upload.component.scss'],
    standalone: false
})
export class ProductsForCustomerTicketUploadComponent implements OnInit {
  isSubmitting = false;
  title = 'Define product';
  formArray: FormArray;
  existingProducts: [];
  productSubTypes: [];
  eventDays;
  duplicatedWeekdays = [];
  showCreatedProducts = false;
  productsSealedByDefault = [];

  constructor(
    public dialogRef: MatDialogRef<ProductsForCustomerTicketUploadComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private taskService: TaskManagementApiService,
    private layoutAlertService: LayoutAlertService,
    private translateService: TranslateService,
  ) {
    this.formArray = new UntypedFormArray([]);
    this.taskService.relatedEventDays(this.data.task.id).subscribe(days => {
      this.eventDays = days;
      this.getDuplicatedWeekdays();
      this.eventDays = this.eventDays.map(obj => ({
        id: obj.id,
        name: this.getDayName(obj.day).substring(0, 3),
        description: this.getDayName(obj.day),
      }));
      this.addEmptyRow();
    });
  }

  addEmptyRow() {
    this.formArray.push(
      new FormGroup({
        title: new UntypedFormControl('', Validators.required),
        product_sub_type: new UntypedFormControl('', Validators.required),
        customer_upload_min_instances_amount: new UntypedFormControl(0, Validators.min(1)),
        days: new UntypedFormControl(this.getEventDay(), minimumArrayLengthValidator(1)),
        customer_uploads_tickets: new UntypedFormControl(true),
        is_sealed: new UntypedFormControl(false),
      }),
    );
  }

  getEventDay() {
    if (this.eventDays?.length === 1) {
      return this.eventDays;
    }
    return [];
  }

  getDayName(day, short = false) {
    const date = new Date(day);
    let weekday = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    if (short) {
      weekday = weekday.map(item => item.substring(0, 3));
    }
    const sufix = this.duplicatedWeekdays.includes(date.getDay())
      ? ` (${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth()).padStart(2, '0')})`
      : '';
    return weekday[date.getDay()] + sufix;
  }

  getDuplicatedWeekdays() {
    const weekdays = [];
    this.eventDays.forEach(day => {
      const weekday = new Date(day.day).getDay();
      if (weekdays.includes(weekday)) {
        this.duplicatedWeekdays.push(weekday);
      } else {
        weekdays.push(weekday);
      }
    });
  }

  removeRow(index) {
    this.formArray.removeAt(index);
  }

  ngOnInit(): void {
    this.taskService.getCustomerProducts(this.data.task.campaign || 0).subscribe(response => {
      this.existingProducts = response['products'];
      this.productSubTypes = response['product_sub_types'];
      this.productsSealedByDefault = response['products_sealed_by_default'];
    });
  }

  closeDialog(action = false) {
    this.dialogRef.close(action);
  }

  submitForm() {
    const payload = this.formArray.getRawValue();
    payload.forEach(productData => {
      productData.days = productData.days.map(day => day.id);
    });

    this.isSubmitting = true;
    this.taskService.productsTaskAction(this.data.task.id, payload).subscribe(
      response => {
        this.closeDialog(true);
      },
      error => {
        this.isSubmitting = false;
        const translatedMsg = error.error.toString().startsWith('task_management.errors.')
          ? error.error
          : `internal error: ${error.error.toString().substring(0, 100)}`;
        this.layoutAlertService.error(this.translateService.instant(translatedMsg));
      },
    );
  }

  toggleCreatedProducts() {
    this.showCreatedProducts = !this.showCreatedProducts;
  }

  checkIsSealed(formRow) {
    const sealed = this.productsSealedByDefault.includes(formRow.get('product_sub_type').value);
    formRow.get('is_sealed').setValue(sealed);
  }

  protected readonly FormGroup = FormGroup;
}
